import React from 'react';
import './Founder.css';

function Founder() {
  return (
    <div className="founder-container">
      <div className="founder-content">
        <div className="founder-image">
          <img src="/divya.jpg" alt="Divya smiling, wearing a burgundy sweater" />
        </div>
        <div className="founder-text">
          <h2>Hi, I'm Divya.</h2>
          <p className="founder-story">
            When I froze embryos, I had no guide—just 27 tabs and a lot of panic. I wrote about my journey, and 58 women DM'd me in a week. Their stories shaped this platform, and yours will too.
          </p>
          <p className="founder-cta">
            Join early, shape the roadmap, and turn late-night spirals into an actionable next step.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Founder; 